var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flights.length > 0)?_c('a-card',{attrs:{"nopad":""}},[_c('div',{staticClass:"booking-title grey darken-1 white--text"},[_c('v-icon',{attrs:{"left":"","small":"","color":"white"}},[_vm._v("flight")]),_c('span',[_vm._v("Flights")])],1),_vm._l((_vm.flights),function(f,index){return _c('FlightRow',{key:index,attrs:{"flight":f}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }